import React, { Component } from 'react';
import { Website } from '../BaseUrl';

export class Footer extends Component {
    displayName = Footer.name

    render() {
        const widTit = { fontFamily: '"proxima-soft","open-sans",Arial,sans-serif', color: "#333", fontWeight: 600, margin: "15px 0", fontSize: "22px" };
        const li = { listStyle: "none", margin: 0 };
        const a = {color: "#636363", fontWeight: 100, fontSize: "16px", textDecoration: "underline"}
        return (
            <footer className="page-footer" style={{ marginTop: "20px", paddingTop: "20px", borderTop: "1px solid #d4d4d4", lineHeight: 1.6, backgroundColor: "#f2f2f2" }}>
                <div className="container">
                    <h2 style={{ color: "#333", fontSize: "25px", margin: "6px 0", fontWeight: 700 }}>Representative 49.9% APR (fixed)</h2>
                    <h5 style={{ fontFamily: '"proxima-nova","open-sans",Arial,sans-serif', fontSize: "19px", fontWeight: 300 }}>Amigo Loans Ireland Limited (trading as "Amigo Loans") is regulated by The Central Bank of Ireland</h5>

                    <div className="row">
                        <div className="col-sm-4 col-xs-12">
                            <h3 style={widTit}>Navigation</h3>
                            <ul style={{ padding: 0 }}>
                                <li style={li}><a style={a} href={`${Website}/Borrower/Apply`}>Apply</a></li>
                                <li style={li}><a style={a} href={`${Website}/Contact`}>Contact us</a></li>
                            </ul>
                        </div>
                        <div className="col-sm-4 col-xs-12">
                            <h3 style={widTit}>Community</h3>
                            <ul style={{ padding: 0 }}>
                                <li style={li}><a style={a} target="_blank" href="https://www.amigoplc.com/">Investors</a></li>
                            </ul>
                        </div>
                        <div className="col-sm-4 col-xs-12">
                            <ul style={{ padding: 0 }}>
                                <li style={li}><a style={a} href={`${Website}/terms`}>Terms &amp; conditions</a></li>
                                <li style={li}><a style={a} href={`${Website}/document/PrivacyPolicy`}>Privacy &amp; Cookie Policy</a></li>
                                <li style={li}><a style={a} href={`${Website}/document/websiteterms`}>Website terms</a></li>
                            </ul>
                        </div>
                    </div>

                    <p style={{ margin: "20px 0", fontSize: "15px", color: "#636363" }}>
                        Amigo Loans, 8 Mount Street Upper Dublin 2. Registered in Ireland, company 
                        registration number 609066. Registered Office: One Earlsfort Centre, Earlsfort Terrace, 
                        Saint Kevin's, Dublin 2. VAT Number IE 3499987UH.
                    </p>
                    <div style={{ fontSize: "13px", padding: "15px", textAlign: "right", borderTop: "1px solid #e5e5e5", color: "#636363" }}>Copyright © {new Date().getFullYear()} - <a href="https://www.amigoloans.ie/">www.amigoloans.ie</a></div>
                </div>
            </footer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js